import { render, staticRenderFns } from "./OrgFilter.vue?vue&type=template&id=b1c1d870&scoped=true&"
import script from "./OrgFilter.vue?vue&type=script&lang=js&"
export * from "./OrgFilter.vue?vue&type=script&lang=js&"
import style0 from "./OrgFilter.vue?vue&type=style&index=0&id=b1c1d870&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c1d870",
  null
  
)

export default component.exports